// Session PJ2F: the messages about survey photos and survey entries that did not reach the office (a photo dropped because the office
// removed its survey, an entry the office did not apply). They are kept on the device until the engineer dismisses them
// (lib/offline/surveyStore.ts). Until now they showed only on the survey sheet, so an engineer who had left it never saw that a photo
// was gone; the same notices now also show on the engineer's home screen, from this one component.
import { useEffect, useState } from "react";
import { SURVEY_NOTICES_EVENT, dismissSurveyPhotoNotice, readSurveyPhotoNotices } from "../../../lib/offline/surveyStore";

/** The notices on this device, kept in step with the event the store raises when one is added or dismissed. */
export function useSurveyPhotoNotices(): string[] {
  const [notices, setNotices] = useState<string[]>(() => readSurveyPhotoNotices());
  useEffect(() => {
    const onNotices = () => setNotices(readSurveyPhotoNotices());
    window.addEventListener(SURVEY_NOTICES_EVENT, onNotices);
    onNotices();
    return () => window.removeEventListener(SURVEY_NOTICES_EVENT, onNotices);
  }, []);
  return notices;
}

export function SurveyPhotoNotices({ notices }: { notices: string[] }) {
  return (
    <>
      {notices.map((n) => (
        <div key={n} role="alert" className="mt-2 rounded-xl border border-ele-card-border p-3 text-sm text-ele-strong" style={{ backgroundColor: "var(--ele-pill-tint-amber)" }} data-survey-photo-notice>
          {n}
          <button type="button" className="ml-2 min-h-11 underline" onClick={() => dismissSurveyPhotoNotice(n)}>
            Dismiss
          </button>
        </div>
      ))}
    </>
  );
}

/** The notices as the engineer's home screen shows them: nothing at all when there are none. */
export function SurveyPhotoNoticesBanner() {
  const notices = useSurveyPhotoNotices();
  if (notices.length === 0) return null;
  return (
    <div className="mb-3">
      <SurveyPhotoNotices notices={notices} />
    </div>
  );
}
